// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class SummaryDocsService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getSummaryDocs(search: string, properties?: any): Observable<any> {
    const params: any = { search };
    if (Array.isArray(properties)) {
      Object.keys(properties).forEach(key => {
        const newParamKey = `properties[${key}]`;
        const newParamValue = properties[key].id;
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService
      .apiCall("GET", `document-archives/summary-docs`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getSummaryDocsGeneral(search: string, data?: any): Observable<any> {
    const params: any = { search };
    const properties = data ? data.properties : undefined;
    const users = data ? data.users : undefined;
    const company = data ? data.company : undefined;
    const subUsers = data ? data.subUsers : undefined;
    const startDate = data ? data.startDate : undefined;
    const endDate = data ? data.endDate : undefined;

    // Single field params
    // properties may be an intentional empty string (Immobili field left unselected) which must reach
    // the BE as properties=; only undefined/null mean "not provided". ApiService keeps empty strings.
    if (properties !== undefined && properties !== null) {
      params['properties'] = properties;
    }
    // users carries a sentinel ("-1" = all, "none" = nobody) or an operator id — never an empty
    // string, which the BE cannot tell apart from "not provided" and would treat as "no filter".
    if (users !== undefined && users !== null) {
      params['users'] = users;
    }
    if (company) {
      params['company'] = company;
    }
    // subUsers carries a sentinel ("-1" = all the company employees, "none" = no employee) or a
    // single employee userId; an empty string means "no employee filter" and is omitted.
    if (subUsers) {
      params['subUsers'] = subUsers;
    }
    if (startDate) {
      params['startDate'] = startDate;
    }
    if (endDate) {
      params['endDate'] = endDate;
    }

    return this.apiService
      .apiCall("GET", `document-archives/summary-docs-general`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getNextInsertionsGeneral(search: string, data?: any): Observable<any> {
    const params: any = { search };
    const master = data ? data.master : undefined;
    const startDate = data ? data.startDate : undefined;
    const endDate = data ? data.endDate : undefined;

    // Single field params
    if (master) {
      params['master'] = master;
    }
    if (startDate) {
      params['startDate'] = startDate;
    }
    if (endDate) {
      params['endDate'] = endDate;
    }

    return this.apiService
      .apiCall("GET", `document-archives/summary-next-insertions`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Get all properties
   *
   * @since 1.0.0
   *
   * @param
   */
  getSummaryDocsProperties(): Observable<any> {
    return this.apiService
      .apiCall("GET", `properties/get-all`)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Get all admin users
   *
   * @since 1.0.0
   *
   * @param
   */
  getSummaryAdminUsers(): Observable<any> {
    return this.apiService
      .apiCall("GET", `users/get-admin`)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  
  /**
   * Get all masters
   *
   * @since 1.0.0
   *
   * @param
   */
  getSummaryDocsMasters(): Observable<any> {
    return this.apiService
      .apiCall("GET", `companies/get-all`)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }
}
